export default "__VITE_ASSET__DMKBeXZj__"